import { BoundType } from './1d-bound-checker';
import { BoundingBoxInfo, getBoundingBoxInfos } from './BoundingBoxInfo';

export type Direction = 1 | -1;

const NULL_INDEX = -1;

/**
 * Find the index of a target that should be make visible in the scroller
 * @param boundingBoxInfos
 * @param direction
 */
const findTargetIndex = (boundingBoxInfos: BoundingBoxInfo[], direction: Direction): number => {
  const index = boundingBoxInfos.findIndex(({ boundType }) => (
    boundType === (BoundType.ClippedBoth + direction) ||
    boundType === BoundType.ClippedBoth
  ));

  if (index !== NULL_INDEX) return index;

  const visibleInfoIndex = boundingBoxInfos.findIndex(({ boundType }) => boundType === BoundType.Visible);
  if (visibleInfoIndex === NULL_INDEX) return NULL_INDEX;

  return visibleInfoIndex + direction;
};

const getPositionOfTargetEdge = (boundingBoxInfo: BoundingBoxInfo, _scrollLeft: number, clientWidth: number, direction: Direction): number => {
  if (direction === 1) {
    return boundingBoxInfo.start;
  }
  return boundingBoxInfo.end - clientWidth;
};

const handleSimpleNavigation = (scrollLeft: number, clientWidth: number, direction: number): number => (
  scrollLeft + clientWidth * direction
);

const getScrollToPosition = (boundingBoxInfos: BoundingBoxInfo[], scrollLeft: number, clientWidth: number, direction: Direction): number => {
  const targetIndex = findTargetIndex(boundingBoxInfos, direction);

  const bbInfo = boundingBoxInfos[targetIndex];

  if (!bbInfo) {
    // Cannot find a suitable target, perform a simple navigation
    return handleSimpleNavigation(scrollLeft, clientWidth, direction);
  }

  if (bbInfo.boundType === BoundType.ClippedBoth) {
    return handleSimpleNavigation(scrollLeft, clientWidth, direction);
  }

  const targetPosition = getPositionOfTargetEdge(bbInfo, scrollLeft, clientWidth, direction);
  if (targetPosition === scrollLeft) {
    // Current scroll is already at the desired scroll position. Perform a simple navigation
    return handleSimpleNavigation(scrollLeft, clientWidth, direction);
  }

  return targetPosition;
};

/**
 *
 * @param parent element of the scroller. Items being scrolled must be the immediate children of the scroller
 * @param scrollLeft distanced moved from the left side of the scroller
 * @param clientWidth current width of the scroller
 * @param direction -1 (left), 1 (right)
 * @returns distance to move
 */
export const getNavigationDistance = (parent: HTMLElement, scrollLeft: number, clientWidth: number, direction: Direction): number => {
  const visibileWindowBoundStart = scrollLeft;
  const visibileWindowBoundEnd = scrollLeft + clientWidth;

  const childElements = [...parent.children] as HTMLElement[];
  const boundingBoxInfos = getBoundingBoxInfos(childElements, clientWidth, visibileWindowBoundStart, visibileWindowBoundEnd);

  return getScrollToPosition(boundingBoxInfos, scrollLeft, clientWidth, direction);
};
